import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/app/(core)/(auth)/forgot-password/ForgotPasswordLayout.tsx");
